<template>
  <admin-wrapper title-translation-path="admin.prints" subtitlePath="admin.printsSubtitle" :inputs="inputs">
  </admin-wrapper>
</template>
<script>
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'PrintsSettings',
  components: {
    AdminWrapper,
  },
  computed: {
    inputs() {
      return [
        {
          name: 'printing_footer',
          translationPath: 'admin.printingFooter',
          subtitle: 'admin.printingFooterSubtitle',
          align: 'start',
          dataType: {
            name: 'textarea',
          },
          inputCols: '5',
          noResize: true,
          rows: '4',
        },
      ];
    },
  },
};
</script>
